import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dashboard",
  "use": "icon-dashboard-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dashboard\"><path d=\"m20 3h-16a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-12a3 3 0 0 0 -3-3zm1 15a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1-1v-12a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1z\" /><path d=\"m8 11a1 1 0 0 0 -1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0 -1-1z\" /><path d=\"m12 9a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0 -1-1z\" /><path d=\"m16 7a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol